import { EllipsisVertical } from "lucide-react";
import { Button } from "src/components/buttons/shadcn-button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/Popover";
import {
  useDeleteEmployeeMutation,
  useUnarchiveEmployeeMutation,
} from "./hook/useArchiveMutations";

const ArchivesListRow = ({ emp, key }) => {
  const { mutate: unarchiveEmployee, isPending: isUnarchiving } =
    useUnarchiveEmployeeMutation();
    
  const { mutate: deleteEmployeeMutate, isPending: isDeleting } =
    useDeleteEmployeeMutation();

  const handleUnarchive = () => {
    unarchiveEmployee(emp.id);
  };

  const handleDelete = () => {
    deleteEmployeeMutate(emp.id);
  };

  return (
    <tr
      key={key}
      className="border-b last:border-0 hover:bg-gray-50 transition text-xs"
    >
      <td className="py-1 uppercase">{emp.employee_code}</td>
      <td className="py-1 flex flex-col">
        <div>
          <p className="font-medium uppercase">{emp.full_name}</p>
          <p className="text-gray-600">{emp.email}</p>
          <p className="text-gray-600">{emp.phone_number}</p>
        </div>
      </td>
      <td className="py-1 uppercase">{emp.department}</td>
      <td className="py-1 uppercase">{emp.designation}</td>
      <td className="py-1 uppercase">
        <span
          className={`transition-colors duration-200 flex flex-wrap w-fit ${
            emp.employeement_type === "CONFIRMED"
              ? "text-green-700"
              : "text-gray-700"
          }`}
        >
          {emp.employeement_type}
        </span>
      </td>
      <td className="py-1 uppercase flex flex-col">
        <div className="text-center">
          <p className="font-medium uppercase">{emp.duration}</p>
          {emp.employeement_type === "CONFIRMED" ? (
            <p className="text-gray-600">
              {(() => {
                if (!emp.end_date) return "--";
                const d = new Date(emp.end_date);
                d.setDate(d.getDate() + 1);
                return d.toISOString().split("T")[0];
              })()}
            </p>
          ) : (
            <p className="text-gray-600">
              {emp.start_date} to {emp.end_date ? emp.end_date : "--"}
            </p>
          )}
        </div>
      </td>
      <td>
        <Popover>
          <PopoverTrigger asChild>
            <button className="p-2 hover:bg-slate-100 rounded-full">
              <EllipsisVertical className="w-5 h-5 text-slate-600 hover:text-primary" />
            </button>
          </PopoverTrigger>

          <PopoverContent className="w-fit p-2 space-y-2 flex flex-col">
            <Button onClick={handleUnarchive}>
              {isUnarchiving ? (
                <span className="loading loading-dots loading-md"></span>
              ) : (
                "Unarchive"
              )}
            </Button>
            <Button
              variant="destructive"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <span className="loading loading-dots loading-md"></span>
              ) : (
                "Delete"
              )}
            </Button>
          </PopoverContent>
        </Popover>
      </td>
    </tr>
  );
};

export default ArchivesListRow;
